/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ScheduleTimeOffRequest = {
    properties: {
        employeeId: {
    type: 'number',
    isRequired: true,
},
        date: {
    type: 'string',
    format: 'date',
},
        startDate: {
    type: 'string',
    format: 'date',
},
        endDate: {
    type: 'string',
    format: 'date',
},
        reason: {
    type: 'string',
},
    },
};